var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreasureChest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_12074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.125C0.5 2.21094 2.05859 0.625 4 0.625V6.75H0.5V4.125ZM0.5 11.5625V7.625H4V12.875H1.8125C1.07422 12.875 0.5 12.3008 0.5 11.5625ZM11.875 7.625V12.875H4.875V7.625H6.625V8.5C6.625 8.99219 7.00781 9.375 7.5 9.375H9.25C9.71484 9.375 10.125 8.99219 10.125 8.5V7.625H11.875ZM14.9375 12.875H12.75V7.625H16.25V11.5625C16.25 12.3008 15.6484 12.875 14.9375 12.875ZM16.25 4.125V6.75H12.75V0.625C14.6641 0.625 16.25 2.21094 16.25 4.125ZM11.875 6.75H10.125V5.875C10.125 5.41016 9.71484 5 9.25 5H7.5C7.00781 5 6.625 5.41016 6.625 5.875V6.75H4.875V0.625H11.875V6.75ZM8.8125 6.3125V8.0625C8.8125 8.30859 8.59375 8.5 8.375 8.5C8.12891 8.5 7.9375 8.30859 7.9375 8.0625V6.3125C7.9375 6.09375 8.12891 5.875 8.375 5.875C8.59375 5.875 8.8125 6.09375 8.8125 6.3125Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_12074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "currentColor",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasureChest);
export default __webpack_public_path__ + "static/media/treasure_chest.730685ec.svg";
export { ForwardRef as ReactComponent };